function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { i18n } from 'invision-core';
import localeKeys from '../../../../../locales/keys';
import { OrderDetailsNotificationHistorySelector } from '../../../../../reducers/selectors/customer.convergent.biller.selectors';
var GiftNotificationHistoryController = /*#__PURE__*/function () {
  function GiftNotificationHistoryController($ngRedux) {
    var _this = this;
    _classCallCheck(this, GiftNotificationHistoryController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      localeKeys: localeKeys
    });
    this.grid = {
      columns: [{
        field: 'Notified',
        displayName: i18n.translate(localeKeys.ORDER_DETAILS.NOTIFICATION_DATE),
        width: 150,
        cellFilter: 'date: \'shortDate\''
      }, {
        field: 'RecipientName',
        displayName: i18n.translate(localeKeys.ORDER_DETAILS.RECIPIENT_NAME),
        minWidth: 250
      }, {
        field: 'RecipientEmail',
        displayName: i18n.translate(localeKeys.EMAIL),
        minWidth: 250
      }, {
        field: 'SenderMessage',
        displayName: i18n.translate(localeKeys.ORDER_DETAILS.MESSAGE),
        cellTemplate: '<div class="ui-grid-cell-contents" ng-bind="row.entity.SenderMessage"></div>',
        minWidth: 250
      }, {
        field: ' ',
        cellTemplate: "<div class=\"c-datatable-drillableCell\"\n                        ng-click=\"grid.appScope.giftNotificationHistoryController.onNotificationClick(row.entity)\"\n                        ng-bind=\"::grid.appScope.giftNotificationHistoryController.localeKeys.ORDER_DETAILS.READ | i18n\">\n                    </div>",
        width: 150
      }],
      onInit: function onInit() {}
    };
    this.messagePopup = {
      onRegisterApi: function onRegisterApi(_ref) {
        var api = _ref.api;
        Object.assign(_this.messagePopup, api);
      }
    };
  }
  return _createClass(GiftNotificationHistoryController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this2 = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          orderNotificationHistory: OrderDetailsNotificationHistorySelector(store)
        };
      };
      var controllerActions = {};
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this2.state = state;
        _this2.actions = actions;
      });
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }, {
    key: "onNotificationClick",
    value: function onNotificationClick(notification) {
      this.selectedNotification = notification;
      this.messagePopup.open();
    }
  }]);
}();
export default {
  template: require('./gift.notification.history.html'),
  controller: GiftNotificationHistoryController,
  controllerAs: 'giftNotificationHistoryController',
  bindings: {}
};